function LoanAuth() {
    return (
        <div className="col-span-full">
            <div className="rounded-xl border border-gray-100 dark:border-gray-700 bg-gray-50/60 dark:bg-gray-700/30 p-5 space-y-4">
                <div>
                    <p className="text-sm font-semibold text-gray-700 dark:text-gray-200">Loan Authorization</p>
                    <p className="text-xs text-gray-400 mt-0.5">Please read before signing</p>
                </div>

                <div className="space-y-3 text-xs text-gray-600 dark:text-gray-300 leading-relaxed">
                    <div>
                        <p className="font-medium text-gray-700 dark:text-gray-200 mb-1">Application Authorization</p>
                        <p>I hereby apply for the loans stated in this application. The information I have provided is, to the best of my knowledge, true and correct. I authorize CedisPay Micro-Credit Enterprise to verify the correctness of this information and to obtain additional information if deemed necessary in evaluating my loan application.</p>
                    </div>

                    <div>
                        <p className="font-medium text-gray-700 dark:text-gray-200 mb-1">Disclosure to Credit Reference Bureaus</p>
                        <p>CedisPay will obtain information about you from the credit reference bureaus to check your credit status and identity. The bureaus will record our enquiries, which may be seen by other institutions that make their own credit enquiries about you. CedisPay shall also disclose your credit transactions to credit reference bureaus in accordance with the <strong>Credit Reporting Regulations, 2020 (L.I 2394)</strong>.</p>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default LoanAuth;
